module.exports = __webpack_public_path__ + "static/media/right-arrow.9b3305ae.svg";